
import React, { useState, useEffect } from 'react';
import './footer.css';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import DialogContacts from '../components/dialogcontacts';


function formatPhoneNumber(phone) {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11 && cleaned.startsWith('7')) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
  }
  return phone;
}

function Footer() {
  const [email, setEmail] = useState('');
  const [footerLogoText, setFooterLogoText] = useState('');
  const [apiData, setApiData] = useState(null);

  
  const [apiUrl, setApiUrl] = useState('');

  
  const [isContactsOpen, setIsContactsOpen] = useState(false);

  
  const openContacts = () => setIsContactsOpen(true);
  const closeContacts = () => setIsContactsOpen(false);

  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => {
        console.error('Ошибка загрузки API URL:', err);
      });
  }, []);

  
  const customIcons = [
    { src: '/templates/icon_1.svg', alt: 'Icon 1', className: 'icon-1' },
    { src: '/templates/icon_2.svg', alt: 'Icon 2', className: 'icon-2' },
    { src: '/templates/icon_3.svg', alt: 'Icon 3', className: 'icon-3' },
  ];

  const targetURL = 'https://gnicpm.ru/services/cpkpt/czentr-profilaktiki-i-kontrolya-potrebleniya-tabaka.html';

  
  const navigationLinks = [
    { name: 'О нас', href: '/about-us' },
    { name: 'Сигареты', href: '/catalog' },
    { name: 'Помощь', href: '/help' },
    { name: 'Блог', href: '/blogs' },
  ];

  
  const clientLinks = [
    { name: 'Покупка и оплата', href: '/purchase-and-payment' },
  ];

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const saveSettings = (emailVal) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 2000);
    });
  };

  
  useEffect(() => {
    if (!apiUrl) return;
    fetch(`${apiUrl}api/info`)
      .then((res) => res.json())
      .then((data) => {
        setApiData(data);
        setFooterLogoText(data.title || '');
      })
      .catch((err) => console.error('Ошибка загрузки /api/info:', err));
  }, [apiUrl]);

  const handleSubscribe = () => {
    if (!emailRegex.test(email)) {
      toast.error('Пожалуйста, введите корректный Email.');
      return;
    }

    const settingsPromise = saveSettings(email);

    toast.promise(settingsPromise, {
      loading: 'Сохраняется...',
      success: <b>Подписка оформлена!</b>,
      error: <b>Не удалось оформить подписку.</b>,
    });

    settingsPromise.then(() => {
      setEmail('');
    });
  };

  const displayedPhone = apiData ? formatPhoneNumber(apiData.phone) : '+7 (495) 300-74-41';
  const whatsappLink = apiData ? `https://api.whatsapp.com/send?phone=${apiData.whatsapp}` : '#';
  const telegramLink = apiData ? apiData.telegram : '#'; 

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-content">
          {/* Блок с «логотипом» (из API) */}
          <div className="footer-logo-section">
            <div className="footer-logo">
              <span className="footer-logo-text">{footerLogoText}</span>
            </div>
            <div className="footer-subtext">
              Бонусы, скидки, специальные предложения и многое другое вы найдете в рассылках нашего сайта. Подпишись! Мы дорожим каждым нашим клиентом и не хотим, чтобы вы пропускали новости о новых товарах и скидках.
            </div>
            <div className="footer-subscription">
              <input
                type="email"
                className="subscription-input"
                placeholder="Email"
                aria-label="Введите ваш Email для подписки"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                className="subscription-button"
                onClick={handleSubscribe}
                aria-label="Подписаться на рассылку"
              >
                Подписаться на рассылку
              </button>
              <div className="footer-icons-container">
                {/* Секция с иконкой WhatsApp */}
                <div className="footer-whatsapp">
                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Связаться через WhatsApp"
                  >
                    <FaWhatsapp className="whatsapp-icon" />
                  </a>
                </div>
                
                {/* Секция с иконкой Telegram */}
                {apiData && apiData.telegram && (
                  <div className="footer-telegram">
                    <a
                      href={`https://t.me/${telegramLink}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Связаться через Telegram"
                    >
                      <FaTelegramPlane className="telegram-icon" />
                    </a>
                  </div>
                )}
                
                {/* Дополнительные иконки */}
                <div className="footer-custom-icons">
                  {customIcons.map((icon, index) => (
                    <a
                      key={index}
                      href={targetURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Дополнительная иконка ${index + 1}`}
                    >
                      <img src={icon.src} alt={icon.alt} className={icon.className} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Секция "Инфо" */}
          <div className="footer-navigation">
            <div className="footer-navigation-title">Инфо</div>
            <div className="footer-navigation-links">
              {navigationLinks.map((link, index) => (
                <a key={index} href={link.href}>
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Секция "Контакты" */}
          <div className="footer-contacts">
            <div className="footer-contacts-title">Контакты</div>
            <div className="footer-contacts-links">
              <a href="mailto:info@cigars-shop.ru" className="footer-contact-email">
                info@cigars-shop.ru
              </a>
              <div className="footer-contact-hours">Доставка по России за 2–5 дней.</div>
              <div className="footer-time-hours">Пн-Вс 10:00-23:00 по Мск</div>
            </div>
            <button className="contacts-button" onClick={openContacts} aria-label="Связаться с нами">
              Связаться с нами
            </button>
          </div>

          {/* Секция "Клиентам" */}
          <div className="footer-clients">
            <div className="footer-clients-title">Клиентам</div>
            <div className="footer-clients-links">
              {clientLinks.map((link, index) => (
                <a key={index} href={link.href}>
                  {link.name}
                </a>
              ))}
            </div>
            <div className="footer-yandex-map">
              <iframe
                src="https://yandex.ru/sprav/widget/rating-badge/1069119407?type=rating"
                width="150"
                height="50"
                frameBorder="0"
                title="Яндекс.Карты"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-warning">
        <p className="warning-text">
          Внимание! Минздрав России предупреждает.<br />
          Курение вредит вашему здоровью! Мы не продаем табачные изделия лицам моложе 18 лет.
        </p>
        <div className="footer-policies">
          <a href="/politic" className="policy-button">Политика конфиденциальности</a>
          <a href="/user-agreement" className="policy-button">Пользовательское соглашение</a>
          <a href="/rules-of-site" className="policy-button">Правила работы сайта</a>
        </div>
        <p className="footer-copyright">
          © {footerLogoText} 2025
        </p>
      </div>

      {/* Включение компонента DialogContacts */}
      <DialogContacts isOpen={isContactsOpen} onClose={closeContacts} />
    </footer>
  );
}

export default Footer;
